import React, { FunctionComponent } from 'react';
import Router from 'next/router';
import { withLoginExperience } from '../../utils/authExperienceNavigation';
import { IneligibleError } from '../../components/register';
import postPatientCompleteAsync from '../../api/register/postPatientCompleteAsync';
import {
  EligibilityCheckResponse,
  AffiliationType,
} from '../../interfaces/register';
import { COVERAGE_REGISTER_URL } from '../../constants/register';
import {
  isCoverageCheckFlow,
  setCompleteAccountMode,
} from '../../lib/coverageCheckStore';

interface Props {
  eligibilityCheck?: EligibilityCheckResponse;
}

const IneligibleErrorContainer: FunctionComponent<Props> = ({
  eligibilityCheck,
}: Props) => {
  const handleContinue = (
    affiliationType: AffiliationType
  ): Promise<boolean | void> => {
    // S7a — coverage-check flow: "Continue without Coverage" routes to Complete Account prefilled +
    // editable (NOT postPatientCompleteAsync -> /eligible-login). Gated so the branded path keeps
    // its existing behavior.
    if (isCoverageCheckFlow()) {
      setCompleteAccountMode({ prefill: true, locked: false });
      Router.push(withLoginExperience(COVERAGE_REGISTER_URL, Router));
      return Promise.resolve();
    }

    return postPatientCompleteAsync(affiliationType).then((response) => {
      if (response.error) {
        window.createErrorEvent(
          {
            controlName: 'ineligible-error-attempt',
            controlText: 'ineligible error',
          },
          {
            errorLocation: 'Ineligible-Error-Container',
            errorType: 'Internal_API',
            errorCode: '',
            errorCause: 'unexpected error',
          }
        );
      } else {
        Router.push(withLoginExperience('/eligible-login', Router));
      }
    });
  };

  return (
    <IneligibleError
      eligibilityCheck={eligibilityCheck}
      onContinue={handleContinue}
    />
  );
};

export default IneligibleErrorContainer;
